<template>
    <div id="sidebar-wrapper">
        <div class="sidebar"
            v-if="isAuthenticated">
            <div class="row">
                <div class="p-2">
                    <img src="/assets/imgs/logo-sm.png">
                    <p class="ml-2 mt-2 small">backoffice</p>
                </div>
            </div>
            <ul class="nav flex-column">
                <li class="nav-item">
                    <a class="nav-link active"
                        href="/dashboard">
                        <svg xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="feather feather-home">
                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                            <polyline points="9 22 9 12 15 12 15 22"></polyline>
                        </svg>
                        Dashboard <span class="sr-only">(current)</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link"
                        href="/galleries">
                        <i class="fa fa-images"></i>
                        Galerias
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link"
                        href="/orders">
                        <i class="fa fa-list"></i>
                        Encomendas
                    </a>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link" href="#">
                        <i class="fa fa-user-friends"></i>
                        Clientes
                    </a>
                </li> -->
            </ul>

            <h5 class="d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
                Definições
            </h5>
            <ul class="nav flex-column mb-2">
                <li class="nav-item">
                    <a class="nav-link"
                        href="/gallery-categories">
                        <i class="fa fa-coins"></i>
                        Categorias
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link"
                        href="/image-sizes">
                        <i class="fa fa-coins"></i>
                        Tamanhos e Preços
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <!-- /#sidebar-wrapper -->
</template>
<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "SideBar",
        computed: {
            ...mapGetters(['isAuthenticated'])
        }
    }
</script>